import { _ as t } from "../internals/export.js";
var a = Math.atanh,
  r = Math.log;
t({
  target: "Math",
  stat: !0,
  forced: !(a && 1 / a(-0) < 0)
}, {
  atanh: function atanh(t) {
    var a = +t;
    return 0 == a ? a : r((1 + a) / (1 - a)) / 2;
  }
});